const errors = {
    CREATE_OFF_CYCLE_PAYROLL: "We couldn't create the off-cycle payroll. Please try again later.",
};

export default errors;
